export default __webpack_public_path__ + "static/media/specimen-two-icon.331441a8.svg";